<template>
  <el-dialog
    append-to-body
    width="900px"
    :title="area_str + ':入驻企业'"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
  >
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="name" label="企业名称"></el-table-column>
      <el-table-column prop="pass_at" label="认证时间"></el-table-column>
    </el-table>
    <div class="pagination-wrap" v-if="total > 0">
      <el-pagination
        :current-page="params.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="params.count"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CompanyDialog",
  data() {
    return {
      visible: false,
      agentId: null,
      tableData: [],
      area_str: "",
      total: 0,
      params: {
        page: 1,
        count: 10,
      },
    };
  },
  methods: {
    toggle(show, row) {
      this.visible = show;
      if (show && row) {
        this.agentId = row.id;
        this.area_str = row.area_str;
        this.params.page = 1;
        this.getCompanyList();
      }
      if (!show) {
        this.reset();
      }
    },
    reset() {
      this.agentId = null;
      this.tableData = [];
      this.total = 0;
      this.params = {
        page: 1,
        count: 10,
      };
      this.visible = false;
    },
    getCompanyList() {
      this.$http
        .get("/admin/companyAgent/company", {
          params: {
            id: this.agentId,
            page: this.params.page,
            count: this.params.count,
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.tableData = res.data.list || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.params.count = val;
      this.params.page = 1;
      this.getCompanyList();
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.getCompanyList();
    },
  },
};
</script>

<style scoped>
.pagination-wrap {
  margin-top: 15px;
  text-align: right;
  padding: 0 30px;
}
</style>